import { Catalog } from "./modules/Catalog.js"; // eslint-disable-line
import { Doughnut } from 'vue-chartjs' // eslint-disable-line
import { QuizManager } from './modules/QuizManager.js'
import { Howl } from 'howler';
import Chart from './components/Chart.vue'

var catalog = new Catalog();

const minDigit = 0;
const maxDigit = 100;
const stageCount = 9;
const completeCount = 25;

var goodSound = new Howl({
    src: './sounds/good.mp3'
});

var badSound = new Howl({
    src: './sounds/bad.mp3'
});

var applauseSound = new Howl({
    src: './sounds/applause.mp3'
});

export default {
    name: 'App',

    components: {
        Chart,
    },

    methods: {
        changeLang: function( lang_code, langLabel ){
            this.lang = lang_code
            this.langLabel = langLabel
        },

        showConfig: function(){
            this.showConfigModal = true
        },

        start: function(){

            if( this.manager == null ){
                this.manager = new QuizManager( minDigit, maxDigit, stageCount, completeCount ); // eslint-disable-line
            }

            this.manager.init()
            this.elapsedSec = 0

            this.timerObj = setInterval( function(){
                this.elapsedSec++;
                if( this.elapsedSec > ( 60 * 5 ) ){
                    this.stop();
                    this.timeOuted();
                }
            }.bind( this ), 1000 );
            this.isPlaying = true;
            this.playSound();

        },

        stop: function(){
            this.isPlaying = false;
            this.elapsedSec = 0;
            clearInterval( this.timerObj );
            this.manager.reset();
        },

        stagedNumber: function( idx ){
            return this.manager.stagedDigit[ idx ];
        },

        judge: function( idx ){
            var result = this.manager.judge( idx );

            if( this.manager.isCompleted() == true ){
                this.playJudgeSound( result );

                this.showCompletedModal = true;
                this.applauseSound.play();
                clearInterval( this.timerObj );

                this.isPlaying = false;
                this.resetPanelColor();
            }else{
                if( result == true ){

                    this.goodSound.play()

                    setTimeout( function(){
                        this.playSound()
                    }.bind( this ), 800 );

                    this.resetPanelColor();

                }else{
                    this.badSound.play()
                    $("div.choice" ).eq( idx ).css('background-color', '#ddf')  // eslint-disable-line
                }
            }

        },

        resetPanelColor: function(){
            $(".choice").each( function(i) {  // eslint-disable-line
                $(this).css('background-color', 'white');  // eslint-disable-line
            })

            $(".choice").each( function(i) {  // eslint-disable-line
                $(this).css('background-color', 'white');  // eslint-disable-line
                $(this).hover( function(){                  // eslint-disable-line
                    $(this).css('background-color', '#ddf');   // eslint-disable-line
                },function(){
                    $(this).css('background-color', '#fff');   // eslint-disable-line
                })
            })

        },

        playJudgeSound: function( result ){
            if( result == true ){
                this.goodSound.play();
            }else{
                this.badSound.play();
            }
        },

        playSound: function(){
            if( this.manager.isCompleted() == true ){
                return;
            }

            var path = this.digitSoundPath( this.manager.getCurrentDigit() );
            var sound = new Howl({
                src: path
            });

            sound.play();
        },

        skip: function(){
            this.showAdviceModal = true;
            this.resetPanelColor();
        },

        digitSoundPath: function( digit ){
            return ( './sounds/' + this.lang + '/' + digit + '.mp3' );
        },

        correctDigit: function(){
            if( this.manager == null ){
                return "-"
            }
            return this.manager.getCurrentDigit();
        },

        correctDigitSpell: function(){
            return this.catalog.getSpell( this.lang , this.correctDigit() );
        },

        timeOuted: function(){
            this.showTimeoutModal = true;
        },

        readAdvice: function(){
            this.manager.skip();
            this.playSound();
        },

        minChanged: function(){

            if( parseFloat( this.minmaxTmp[0] ) <= 0 ){
                this.$nextTick( () => {
                    this.minmaxTmp[0] = "0"
                })
            }
        },

        maxChanged: function(){
            if( parseFloat( this.minmaxTmp[1] ) >= 1000 ){
                this.$nextTick( () => {
                    this.minmaxTmp[1] = "1000"
                })
            }
        },

        applyConfig: function(){
            this.stageCount= this.stagecountTmp;
            this.completeCount = this.completcountTmp;

            this.manager = new QuizManager( Number( this.minmaxTmp[0] ), Number( this.minmaxTmp[1] ), Number( this.stagecountTmp ), Number( this.completeCount ) )

            this.showConfigModal = false
        },

        setRange: function(min, max ){
            this.minmaxTmp = [ min, max ]
        },

        chartData: function(){
            var data = [];
            if( this.manager == null ){
                data = [ 0, 0 ]
            }else{
                data = [ this.manager.getCorrectCount(), this.manager.getMissCount() ]
            }

            return {
                labels: ["正解", "不正解"],
                datasets: [{
                    data: data,
                    backgroundColor:["rgb(194, 238, 255)","rgb(255, 198, 194)"],
                }],
                options: [],
            }
        },

    },

    computed: {

        progress_percent: function(){
            if( this.manager == null ){
                return 0
            }
            return this.manager.progressPercent();
        },

        skip_percent: function(){
            if( this.manager == null ){
                return 0
            }
            return this.manager.skipPercent();
        },

        miss_percent: function(){
            if( this.manager == null ){
                return 0
            }
            return this.manager.missPercent();
        },

        elapsedSecFormatted: function(){
            if( this.elapsedSec == null ){
                return "00:00";
            }

            var m = this.elapsedSec / 60 | 0;
            var s = this.elapsedSec % 60;
            if( m < 10 ){
                m = "0" + m;
            }
            if( s < 10 ){
                s = "0" + s;
            }
            return ( m + ":" + s );
        },

        choice: function(){
            var ar = [];

            for( var i = 0 ; i < this.stageCount ; i++ ){
                ar.push( i );
            }

            return ar;
        },

        progress: function(){
            if( this.manager == null ){
                return 0
            }
            return this.manager.getCorrectCount()
        },

        skipcount: function(){
            if( this.manager == null ){
                return 0
            }
            return this.manager.getSkipCount()
        },

        missCount: function(){
            if( this.manager == null ){
                return 0
            }
            return this.manager.getMissCount()
        },

        score: function(){
            if( this.manager == null ){
                return " 0 / " + completeCount
            }
            return this.manager.getProgressScore()
        },

        panelCol: function(){


            if( this.stageCount <= 4 ){
                return 6
            }

            if( this.stageCount == 6 ){
                return 4
            }

            if( this.stageCount <= 9 ){
                return 4
            }

            if( this.stageCount <= 16 ){
                return 3
            }
        },

        configError: function(){
            if( ( this.minmaxTmp[1] - this.minmaxTmp[0]) < this.stagecountTmp ){
                return true
            }
            return false
        }
    },

    data: function(){
        return{
            lang: "de",
            langLabel: "ドイツ語",
            langs: [
                { label: 'ドイツ語', lang: 'de' },
                { label: 'フランス語', lang: 'fr' },
                { label: '英語', lang: 'en' },
                { label: '中国語', lang: 'zh' },
                { label: '日本語', lang: 'ja' },
                { label: '韓国語', lang: 'ko' },
                { label: 'スペイン語', lang: 'es' },
                { label: 'ロシア語', lang: 'ru' },
            ],
            minDigit: minDigit,
            maxDigit: maxDigit,
            stageCount: stageCount,
            manager: null,
            isPlaying: false,
            goodSound: goodSound,
            badSound: badSound,
            applauseSound: applauseSound,
            timerObj: null,
            elapsedSec: 0,
            showTimeoutModal: false,
            showCompletedModal: false,
            showAdviceModal: false,
            catalog: catalog,
            minmaxTmp: [ 0, 100 ],
            stagecountTmp: "9",
            completcountTmp: "25",
            showConfigModal: false,
        }
    },

};

